var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"justify-center"},[_vm._v(_vm._s(_vm.$t("configuration")))]),_c('v-card-text',[_vm._l((_vm.opcionesVisibles),function(option){return [_c('SettingItem',{key:'config_' + option.key,attrs:{"config":_vm.config,"option":option},on:{"change:value":_vm.updateConfig}})]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }